import { Component, Input } from '@angular/core';

@Component({
  selector: 'opac-card-item-description',
  templateUrl: './card-item-description.component.html',
  styleUrls: ['./card-item-description.component.scss']
})
export class CardItemDescriptionComponent {
  @Input() description: string = '';

  @Input() maxLines = 2;
}
